import { FC, useEffect, useState } from "react";
import { useStore } from "../../utils/store";
import { useNavigate, useParams } from "react-router";
import { IStep } from "../../types";

function getNeighbors(arr: IStep[], currentId: any) {
  const currentIndex = arr.findIndex((obj) => obj.id === currentId);

  if (currentIndex === -1) return [];

  return arr.reduce((result: any, item, index) => {
    if (index >= currentIndex - 4 && index <= currentIndex + 4) {
      result.push(item);
    }
    return result;
  }, []);
}

interface ContentTableProps {
  step_id: any;
  article_id: any;
}

// export const ContentTable: FC<ContentTableProps> = ({ step_id, article_id }) => {
export const ContentTable = () => {
  const [showAll, setShowAll] = useState(false);
  const { getSteps, steps, loaded_article } = useStore();
  const { article_id, step_id } = useParams();
  const history = useNavigate();

  useEffect(() => {
    if (loaded_article != article_id) {
      getSteps(article_id);
    }
  }, [article_id]);

  if (!loaded_article) return <div></div>;
  const curStep = step_id || steps[0].id;
  const filteredSteps: IStep[] = showAll ? steps : getNeighbors(steps, curStep);

  return (
    <div className="table">
      {filteredSteps.map((step) => (
        <p
          className={step.id == curStep ? "step active_step" : "step"}
          onClick={() => history(`/${article_id}/${step.id}`)}
        >
          {step.heading}
        </p>
      ))}
      <div className="step" onClick={() => setShowAll(!showAll)}>
        {showAll ? <>&#708;&#708;&#708;</> : <> &#709;&#709;&#709;</>}
      </div>
    </div>
  );
};
